
export default {
  name: 'CourseQuiz',
  props: {
    // eslint-disable-next-line vue/prop-name-casing
    id: {
      default: '65313b0c6dafac00142eed86',
      type: String
    },
  },
  data(){
    return{
      interactLoaded:false
    }
  },
}
